import { render, staticRenderFns } from "./SupplierEditDialog.vue?vue&type=template&id=36683d40&scoped=true"
import script from "./SupplierEditDialog.vue?vue&type=script&lang=js"
export * from "./SupplierEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36683d40",
  null
  
)

export default component.exports